import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextSignalLip = () => {

return(
<div>
    
<Typography variant="h6" >
APOB (with NPC1L1) Novel gene-by-environment interactions: APOB and NPC1L1 variants affect the relationship between dietary and total 
plasma cholesterol (SNPedia)<br /><br /> 

<br /><br /> 

Sources: <br /><br />
https://www.ncbi.nlm.nih.gov/gtr/tests/593407/    <br />
https://www.mdpi.com/1422-0067/22/8/4182 <br />

 
</Typography>

</div>
)
}